export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.313.0-0ca8686",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
